import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as styles from '../EntityPanelSelector.module.css';

/**
 * FilterDropdown Component
 * Renders the filter by dropdown
 */
function FilterDropdown({ filterOptions, selectedFilterValue, onFilterChange, label }) {
  const { t } = useTranslation();
  
  if (!filterOptions || filterOptions.length === 0) {
    return null;
  }

  return (
    <div className={styles.filterByRow}>
      <span className={styles.filterByLabel}>{label || t('reports.filters.filterBy')}</span>
      <select
        className={styles.filterBySelect}
        value={selectedFilterValue}
        onChange={(e) => onFilterChange(e.target.value)}
      >
        {filterOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

FilterDropdown.propTypes = {
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  selectedFilterValue: PropTypes.string,
  onFilterChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

FilterDropdown.defaultProps = {
  filterOptions: [],
  selectedFilterValue: '',
  label: '',
};

export default FilterDropdown;

